/**
 * 便捷获取对象属性，避免大量非空判断
 * @param {Object|Array} obj 目标对象或数组
 * @param {string} keys 路径字符串
 * @param {*} [defaultVal] 没有对应属性值时返回的默认值
 * @returns 目标属性值
 */
function deepGet (obj, keys, defaultVal) {
  keys = keys.split('.');
  const result = keys.reduce(
    (currentObj, key) => (currentObj && currentObj[key] !== null && currentObj[key] !== undefined ? currentObj[key] : null),
    obj
  );
  return result || defaultVal;
}

export default deepGet;



// WEBPACK FOOTER //
// ./node_modules/@kk/utils/src/deepGet.js